module.exports = __webpack_public_path__ + "static/media/team2.1e90af99.png";